import DividerEdit from "./edit"
import DividerView from "./view"

export default { view: DividerView, edit: DividerEdit }
